import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';


import { CedunoService } from '../_services'
import { PartidaCedunoService } from '../_services'



/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-cedunos',
  templateUrl: './cedunos.component.html',
  styleUrls: ['./cedunos.component.scss']
})



export class CedunosComponent implements AfterViewInit {
  displayedColumns: string[] = ['created', 'consignor_name', 'description', 'code', 
  'monto_base', 'iva', 'saldo_antes', 'variacion_saldo', 'saldo_despues', 
  'iva_antes', 'iva_despues'];
  cedunoDatabase: CedunoDatabase | null;
  data: CedunoIssue[] = [];
  coins;
  la_fecha_corte;
  cedunoForm: FormGroup;
  partidaForm: FormGroup;
  form_ceduno: []
  ceduno: any = {};
  partidas_ceduno: any = {};


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
          private formBuilder: FormBuilder,
          private cedunoService: CedunoService,
          private partidas_cedunoService: PartidaCedunoService,
          private _httpClient: HttpClient, 
          private _hs: HttpService,
          private snackBar: MatSnackBar,
    ) { }


  ngOnInit() {
    this.cedunoForm = this.formBuilder.group({
      consignante_id: ['', Validators.required],
      folio_serie: ['', Validators.required],
      fecha: ['', Validators.required],
      num_pedimento: ['', Validators.required],
      factura: ['', Validators.required],
      proveedor: ['', Validators.required],
      mercancia: ['', Validators.required],
      valor_aduana_usd: ['', Validators.required],
      tipo_cambio: ['', Validators.required],
      valor_aduana_mxn: ['', Validators.required],
      anticipo: ['', Validators.required],
      revolvente: ['', Validators.required],
      fecha_anticipo: ['', Validators.required],
      iva_acreditable: ['', Validators.required],
      total_gastos_comprobados: ['', Validators.required],
      monto_anticipo: ['', Validators.required],
      monto_revolvente: ['', Validators.required],
      saldo_por_pagar: ['', Validators.required],
      su_complemento_por: ['', Validators.required],
      cantidad_con_letra: ['', Validators.required],
      fondo_revolvente_actualizado: ['', Validators.required],
    });


    this.partidaForm = this.formBuilder.group({
      folio_partida: ['', Validators.required],
      descripcion: ['', Validators.required],
      num_factura: ['', Validators.required],
      subtotal: ['', Validators.required],
      iva_acreditable: ['', Validators.required],
      total_partida: ['', Validators.required],
    });

     
  }

  onSubmitP() {
    console.log("submitted el form partida_ceduno")
    this.partidas_ceduno["folio_partida"] = this.partidaForm.value.folio_partida
    this.partidas_ceduno["descripcion"] = this.partidaForm.value.descripcion
    this.partidas_ceduno["num_factura"] = this.partidaForm.value.num_factura
    this.partidas_ceduno["subtotal"] = this.partidaForm.value.subtotal
    this.partidas_ceduno["iva_acreditable"] = this.partidaForm.value.iva_acreditable
    this.partidas_ceduno["total_partida"] = this.partidaForm.value.total_partida

    console.log(this.partidas_ceduno)
     this.partidas_cedunoService.registrar(this.partidas_ceduno, this.partidas_ceduno["folio_partida"])
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Partida Ceduno guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }

  onSubmit() {
    console.log("submitted el form ceduno")
    console.log(this.cedunoForm.value.razon)
    // hacer un servicio e invocarlo
    
    this.ceduno["consignante_id"] = this.cedunoForm.value.consignante_id
    this.ceduno["folio"] = this.cedunoForm.value.folio_serie
    this.ceduno["fecha"] = this.cedunoForm.value.fecha
    this.ceduno["num_pedimento"] = this.cedunoForm.value.num_pedimento
    this.ceduno["factura"] = this.cedunoForm.value.factura
    this.ceduno["proveedor"] = this.cedunoForm.value.proveedor
    this.ceduno["mercancia"] = this.cedunoForm.value.mercancia
    this.ceduno["valor_aduana_usd"] = this.cedunoForm.value.valor_aduana_usd
    this.ceduno["tipo_de_cambio"] = this.cedunoForm.value.tipo_cambio
    this.ceduno["valor_aduana_mxn"] = this.cedunoForm.value.valor_aduana_mxn
    this.ceduno["anticipo"] = this.cedunoForm.value.anticipo
    this.ceduno["revolvente"] = this.cedunoForm.value.revolvente
    this.ceduno["fecha_anticipo"] = this.cedunoForm.value.fecha_anticipo
    this.ceduno["iva_acreditable"] = this.cedunoForm.value.iva_acreditable
    this.ceduno["total_gastos_comprobados"] = this.cedunoForm.value.total_gastos_comprobados
    this.ceduno["monto_anticipo"] = this.cedunoForm.value.monto_anticipo
    this.ceduno["monto_revolvente"] = this.cedunoForm.value.monto_revolvente
    this.ceduno["saldo_por_pagar"] = this.cedunoForm.value.saldo_por_pagar
    this.ceduno["su_complemento_por"] = this.cedunoForm.value.su_complemento_por
    this.ceduno["cantidad_con_letra"] = this.cedunoForm.value.cantidad_con_letra
    this.ceduno["fondo_revolvente_actualizado"] = this.cedunoForm.value.fondo_revolvente_actualizado

    console.log("la ceduno es ")
    console.log(this.ceduno)
     this.cedunoService.registrar(this.ceduno)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Ceduno guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }


  ngAfterViewInit() {

    this.cedunoDatabase = new CedunoDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.cedunoDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
          console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface CedunoApi {
  items: CedunoIssue[];
  total_count: number;
}

export interface CedunoIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class CedunoDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<CedunoApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cedunos.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<CedunoApi>(requestUrl);
  }
}
